export const resName = state => state.resName;